<app-instruction-page [page]="page"></app-instruction-page>